// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import BookManager from "../../components/dashboard/BookManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <BookManager />
    </DashboardLayout>
  );
}
